import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function Title(props){
  const [icons] = useEnvValue('icons')
  const [title] = useEnvValue('strings.planting.title')
  const [helpLink] = useEnvValue('planting.helpLink')

  return (
    <div className="text">
      <p>{title}</p>
      { helpLink === null
        ? null
        : <a href={helpLink.url} target={helpLink.target} title={helpLink.title}><img src={icons.help}/></a>
      }
    </div>
  )
}

export default observer(Title)